import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CashPickupPage } from './cash-pickup';

@NgModule({
  declarations: [
    CashPickupPage,
  ],
  imports: [
    IonicPageModule.forChild(CashPickupPage),
  ],
})
export class CashPickupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cash-pickup/cash-pickup.module.ts